import type { GatsbyBrowser } from "gatsby"
import "@fontsource/inter/400.css"
import "@fontsource/inter/500.css"
import "@fontsource/inter/700.css"
import "@fontsource/inter/800.css"
import "@fontsource/jetbrains-mono/400.css"
import "./src/styles/global.css"

const SUPPORTED_LOCALES = ["es", "fr", "de", "zh-CN"]

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location }) => {
  const match = location.pathname.match(/^\/([a-z]{2}(?:-[A-Z]{2})?)\//)
  const locale = match?.[1]
  document.documentElement.lang = locale && SUPPORTED_LOCALES.includes(locale) ? locale : "en"
}

export const onClientEntry: GatsbyBrowser["onClientEntry"] = async () => {
  if (process.env.NODE_ENV !== "production") {
    const React = await import("react")
    const ReactDOM = await import("react-dom")
    const axe = await import("@axe-core/react")
    axe.default(React.default, ReactDOM.default, 1000)
  }
}
